class PortraitBioToggler {
  constructor(togglers) {
    this.togglers = togglers
    this.portraitSections = [...document.querySelectorAll('.portrait__section')]
    this.portraitItems = [...document.querySelectorAll('.portrait__item')]

    this.init()

  }

  init() {
    for (let trigger of this.togglers) {
      trigger.addEventListener('click', (e) => {

        // x -> close all, no check needed
        if (('portraitBioClose' in trigger.dataset) || trigger.getAttribute('aria-expanded') == 'true') {
          this.togglers.map(el => el.dispatchEvent(new Event("closePortraitBio")))
          return
        }

        //first, close all other
        this.togglers.map(el => el !== trigger ? el.dispatchEvent(new Event("closePortraitBio")) : null)
        // updaten dom order 
        this.moveTargetInToPlace(trigger)
        // toggle the current
        this.toggle(e, trigger)

      })
      trigger.addEventListener('closePortraitBio', (e) => this.toggle(e, trigger, true))

    }

    this.portraitSections.map(portraitSection => portraitSection.addEventListener("transitionend", (ev) => {
      if (portraitSection.style.getPropertyValue('--self-height') === '0px') {
        portraitSection.classList.add('hide')
      } else {
        // Scroll in to view after animation is ended.
        portraitSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
      }
    }))

  }

  toggle(e, el, forceClose = false) {
    e.preventDefault()
    let isClose = el.getAttribute('aria-expanded') == 'false'

    // stop code if already closed
    if (forceClose && isClose) {
      return
    }

    const targetElement = document.getElementById(el.dataset.portraitBioToggle)
    el.setAttribute('aria-expanded', isClose ? 'true' : 'false')


    if (!isClose) {

    } else {
      targetElement.classList.toggle('hide', !isClose)
    }


    targetElement.style.setProperty('--self-height', (isClose ? targetElement.scrollHeight : 0) + 'px')
    targetElement.style.setProperty('--self-opacity', isClose ? 1 : 0)

  }


  moveTargetInToPlace(trigger) {

    const clickedRect = trigger.closest('.portrait__item').getBoundingClientRect()
    const currentRow = this.portraitItems.filter(el => {
      const elRect = el.getBoundingClientRect()
      return elRect.top === clickedRect.top
    })
    const lastElementInRow = currentRow[currentRow.length - 1]
    const elementToMove = document.getElementById(trigger.dataset.portraitBioToggle)
    // move the element to the new position
    elementToMove.parentNode.insertBefore(elementToMove, lastElementInRow.nextSibling)


  }



}

export default PortraitBioToggler
